import { IRootState } from '../../../store'
import { IChildbirthOBOptionsState } from '../store/options.types'

export const getChildbirthOBOptionsSelector = (state: IRootState): IChildbirthOBOptionsState =>
  state.options.childbirthOBOptions
